import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { LoadingSpinner } from "../../Loaders/Spinners/LoadingSpinner";
import { BUTTON__CONTENT_CLASS, SPINNER_CLASSNAME_PREFIX } from "../constants";
import { buttonContentTextColor } from "../styles/base.styles";
import { SPINNER_ANIMATION_DURATION_IN_MS } from "../styles/spinner.styles";
import * as styles from "./ButtonInnerWithLoadingState.styles";
var textColorModeToSpinnerColorModeMapping = {
  light: 'dark',
  dark: 'light',
  brand: 'light'
};
export var ButtonInnerWithLoadingState = function ButtonInnerWithLoadingState(_ref) {
  var children = _ref.children,
    compact = _ref.compact,
    loading = _ref.loading,
    textColorMode = _ref.textColorMode;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSpinnerAnimating = _useState2[0],
    setIsSpinnerAnimating = _useState2[1];
  var spinnerRef = useRef(null);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: BUTTON__CONTENT_CLASS,
    $_css: buttonContentTextColor[textColorMode]
  }, !loading && !isSpinnerAnimating && children, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: SPINNER_CLASSNAME_PREFIX,
    in: loading,
    nodeRef: spinnerRef,
    onEnter: function onEnter() {
      return setIsSpinnerAnimating(true);
    },
    onExited: function onExited() {
      return setIsSpinnerAnimating(false);
    },
    timeout: SPINNER_ANIMATION_DURATION_IN_MS,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(_StyledLoadingSpinner, {
    colorMode: textColorModeToSpinnerColorModeMapping[textColorMode],
    ref: spinnerRef,
    size: compact ? 'small' : 'medium',
    $_css2: compact ? undefined : styles.loadingSpinner
  })));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledLoadingSpinner = /*#__PURE__*/_styled2(LoadingSpinner).withConfig({
  displayName: "ButtonInnerWithLoadingState___StyledLoadingSpinner",
  componentId: "sc-7j622c-0"
})(["", ""], function (p) {
  return p.$_css2;
});